myschedules-index
  .order-wrap(each="{order_id in this.opts.orders}")
    orders-planner-props(tag-scope="{dataScopeOrder(order_id)}" data-edit="{false}")
    orders-planner-lines(tag-scope="{dataScopeOrder(order_id)}" data-edit="{false}")
    orders-planner-task-editor(if="{true}" tag-scope="orders_planner_task_editor" order-id="{order_id}")
  orders-planner-dialog-tooltip-schedule(tag-scope="orders_planner_dialog_tooltip_schedule")
  orders-planner-dialog-tooltip-orders-phase(tag-scope="orders_planner_dialog_tooltip_orders_phase")
  forms-schedules-update(tag-scope="forms_schedules_update")
  forms-schedules-destroy(tag-scope="forms_schedules_destroy")
  orders-planner-scroll(tag-scope="{orders_planner}")
  script(type="typescript").
    this.mixin('myschedules.index');
  style(scoped).
    .task {
      margin-bottom: 150px;
    }
